/**
 * Batch-number cell of the desktop check-inventory table (`./CheckInventoryModalTableConfig.tsx`).
 */
import { Flex } from "@ryerson/frontend.layout";
import { useTheme } from "@ryerson/frontend.theme";
import { Typography } from "@ryerson/frontend.typography";
import React from "react";

interface CheckInventoryModalTableBatchNumberCellProps {
	itemData?: string | number | object | boolean;
}

/** Renders the row's `batchNumber` value as dark-gray text. */
const CheckInventoryModalTableBatchNumberCell: React.FC<
	CheckInventoryModalTableBatchNumberCellProps
> = ({ itemData }) => {
	const { theme } = useTheme();
	const { darkGray } = theme.colors.primary;

	return (
		<Flex>
			<Typography color={darkGray}>{itemData}</Typography>
		</Flex>
	);
};

export default CheckInventoryModalTableBatchNumberCell;
